import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {
  BOX_SHADOWS,
  FONTS,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from "../../constants";
import { personaType, stateType } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import { PERSONA_IMAGES } from "./PersonaPredictionBox";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "30%",
      backgroundColor: "white",
      //   border: "solid",
      boxShadow: BOX_SHADOWS,
      borderWidth: "2px",
      borderRadius: "10px",
      height: "520px",
    },
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      fontFamily: FONTS,
    },
    personaIcon: { width: "40px", height: "40px" },
    test: {
      width: "95%",
      marginLeft: "8px",
      borderRadius: "0px",
    },
    selected: {},
    rootMenuItem: {
      color: PRIMARY_COLOR,
      "&$selected": {
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.05)",
        },
      },
    },
    deleteIcon: {
      transition: "0.2s",
      color: PRIMARY_COLOR,
      "&:hover": { color: "rgba(0,0,0,0.6)" },
    },
  })
);

export default function SimpleList({ state }: stateType) {
  const classes = useStyles();

  function handleClick(i: number) {
    state.saveState.personaPrediction.personaselected = i;
    state.setSaveState(state.saveState);
  }
  function handleDelete() {
    state.setIsDeletePersonaOpen(true);
  }
  function handleEdit(persona: personaType, personaIndex: number) {
    state.setEditingPersona(personaIndex);

    const personaPic = persona.avatar;
    const fn = (element) => element === personaPic;
    const index = PERSONA_IMAGES.findIndex(fn);

    state.setPersonaAvatarSelected(index);
    state.setPersonaName(persona.name);
    state.setIsPersonaPopupOpen(true);
  }
  function handleNewPersona() {
    state.setPersonaName("");
    state.setEditingPersona(-1);
    state.setIsPersonaPopupOpen(true);
  }

  const nPersonas = state.saveState.personaPrediction.personas.length;

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="main mailbox folders">
        {state.saveState.personaPrediction.personas.map((persona, i) => (
          <ListItem
            button
            selected={state.saveState.personaPrediction.personaselected === i}
            className={classes.test}
            classes={{
              selected: classes.selected,
              root: classes.rootMenuItem,
            }}
            onClick={() => handleClick(i)}
          >
            <ListItemIcon>
              <img
                style={{ opacity: 1 }}
                src={persona.avatar}
                className={classes.personaIcon}
              ></img>
            </ListItemIcon>
            <ListItemText>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  style={{
                    fontFamily: FONTS,
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginLeft: "-10px",
                  }}
                >
                  {persona.name}
                </div>
                <div style={{ marginLeft: "auto", marginRight: "0px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div
                      style={{ height: "0px", marginRight: "10px" }}
                      className={classes.deleteIcon}
                      onClick={() => handleEdit(persona, i)}
                    >
                      <EditIcon></EditIcon>
                    </div>
                    {nPersonas === 1 ? (
                      <div></div>
                    ) : (
                      <div
                        style={{ height: "0px" }}
                        className={classes.deleteIcon}
                        onClick={handleDelete}
                      >
                        {" "}
                        <DeleteIcon></DeleteIcon>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ListItemText>
          </ListItem>
        ))}
        {nPersonas >= 6 ? (
          <div></div>
        ) : (
          <ListItem button style={{ fontFamily: FONTS, marginTop: "15px" }}>
            <Avatar
              style={{
                backgroundColor: "rgba(0,0,0,0.1)",
                border: "solid",
                borderWidth: "2px",
                marginLeft: "5px",
                borderColor: SECONDARY_COLOR,
                width: "20px",
                height: "20px",
              }}
            >
              <AddIcon style={{ color: SECONDARY_COLOR }}></AddIcon>
            </Avatar>
            <ListItemText onClick={handleNewPersona}>
              <div
                style={{
                  fontFamily: FONTS,
                  fontWeight: "bold",
                  marginLeft: "16px",
                }}
              >
                {"Add New Persona..."}
              </div>
            </ListItemText>
          </ListItem>
        )}
      </List>
    </div>
  );
}

export function PersonaSelectBox({ state }: stateType) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <BoxHeader
        title={`Persona Select`}
        toolTip={
          "Create, edit and delete personas. Use personas to experiment with particular scenarios and profiles"
        }
        line={true}
      ></BoxHeader>
      <SimpleList state={state}></SimpleList>
    </div>
  );
}
